/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TargetGroupOutput
 */
export interface TargetGroupOutput {
  /**
   *
   * @type {number}
   * @memberof TargetGroupOutput
   */
  index: number;
  /**
   *
   * @type {string}
   * @memberof TargetGroupOutput
   */
  packageCode: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TargetGroupOutput
   */
  channels: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TargetGroupOutput
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TargetGroupOutput
   */
  targetGroupId: string;
}

export function TargetGroupOutputFromJSON(json: any): TargetGroupOutput {
  return TargetGroupOutputFromJSONTyped(json, false);
}

export function TargetGroupOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TargetGroupOutput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    index: json["index"],
    packageCode: json["packageCode"],
    channels: json["channels"],
    name: json["name"],
    targetGroupId: json["targetGroupId"],
  };
}

export function TargetGroupOutputToJSON(value?: TargetGroupOutput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    index: value.index,
    packageCode: value.packageCode,
    channels: value.channels,
    name: value.name,
    targetGroupId: value.targetGroupId,
  };
}
